import { LocalizedLinkDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/localized-link-display-model';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { I18nService } from '@/core/services/i18nService';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'core-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public portalkonfiguration : PortalkonfigurationDisplayModel;

  public get linkImpressum(): string{
    let impressum: LocalizedLinkDisplayModel | undefined = this.languageService.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.impressen);

    return impressum?.link ?? "";
  };
  
  public get linkDatenschutzbestimmung(): string{
    let datenschutzbestimmung: LocalizedLinkDisplayModel | undefined = this.languageService.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.datenschutzbestimmungen);

    return datenschutzbestimmung?.link ?? "";
  };

  public get aktuelleVersion(): string {
    if(environment.production)
      return this.portalkonfiguration.version?.substring(0, this.portalkonfiguration.version?.lastIndexOf('.')) ?? "";

    let version: string = this.portalkonfiguration.version?.substring(0, this.portalkonfiguration.version?.lastIndexOf('.')) ?? ""
    let build: string = this.portalkonfiguration.version?.substring(this.portalkonfiguration.version?.lastIndexOf('.') + 1) ?? ""

    return `${version} (Build ${build})`;
  }

  constructor(protected route : ActivatedRoute, protected languageService: I18nService) { }

  ngOnInit(): void {
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
  }

}
